import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { api, apiErrorMessage } from '../lib/api'
import { useAuth } from '../lib/auth'

export function CheckoutSuccessPage() {
  const auth = useAuth()
  const nav = useNavigate()
  const [params] = useSearchParams()
  const sessionId       = params.get('session_id') ?? ''
  const paymentIntentId = params.get('payment_intent') ?? ''
  const [error, setError] = useState<string | null>(null)
  const [phase, setPhase] = useState<'confirming' | 'redirecting'>('confirming')

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      try {
        // Fallback path: ask the backend to provision the challenge_account
        // from the paid session/PaymentIntent in case the Stripe webhook
        // hasn't fired yet. Idempotent server-side.
        if (paymentIntentId) {
          await api.post('/trader/checkout/confirm', { paymentIntentId })
        } else if (sessionId) {
          await api.post('/trader/checkout/confirm', { sessionId })
        }
        await auth.refresh()
        if (cancelled) return
        setPhase('redirecting')
        setTimeout(() => { if (!cancelled) nav('/', { replace: true }) }, 800)
      } catch (err) {
        if (cancelled) return
        setError(apiErrorMessage(err))
      }
    }
    void run()
    return () => { cancelled = true }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, paymentIntentId])

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 'var(--space-6)', background: 'var(--bg-canvas)' }}>
      <div style={{ width: '100%', maxWidth: 420, background: 'var(--bg-surface)',
        border: '1px solid var(--border-subtle)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-6)',
        textAlign: 'center', boxShadow: 'var(--shadow-md)' }}>
        <div style={{ margin: '0 auto var(--space-3)', display: 'flex', height: 56, width: 56,
          alignItems: 'center', justifyContent: 'center', borderRadius: 999,
          background: error ? 'var(--color-danger-subtle)' : 'var(--color-success-subtle)',
          color: error ? 'var(--color-danger-text)' : 'var(--color-success-text)' }}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.5} style={{ width: 32, height: 32 }} aria-hidden>
            {error ? <path d="M6 6 l12 12 M18 6 l-12 12" /> : <path d="M5 12 l5 5 L20 7" />}
          </svg>
        </div>
        <h1 style={{ fontSize: 'var(--text-xl)', fontWeight: 700, color: 'var(--text-primary)', marginBottom: 'var(--space-2)' }}>
          {error ? 'Could not activate your challenge' : 'Payment successful'}
        </h1>
        <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-tertiary)' }}>
          {error
            ? error
            : phase === 'confirming' ? 'Activating your challenge…' : 'Redirecting to the dashboard…'}
        </p>
        {error && (
          <button type="button" className="btn btn--secondary btn--sm" style={{ marginTop: 16 }}
            onClick={() => nav('/challenge')}>
            Back to challenge picker
          </button>
        )}
      </div>
    </div>
  )
}
